export const checkIsAwgOwner = (ownerId) =>
  ownerId === parseInt(process.env.REACT_APP_AWG_ID);
